<template>
  <v-app>
    <v-main>
      <router-view v-slot="{ Component, route }">
        <transition name="router-anim">
          <component :is="Component" />
        </transition>
      </router-view>
      <v-dialog theme="dark" v-model="httpStore.showLoading" max-width="320" persistent>
        <v-list class="py-2" color="primary" elevation="12" rounded="lg">
          <v-list-item title="Processing Request...">
            <template v-slot:prepend>
              <div class="pe-4">
                <v-img :src="dell_logo" width="40" alt="Dell Partner Program" />
              </div>
            </template>

            <template v-slot:append>
              <v-progress-circular color="primary" indeterminate="disable-shrink" size="16"
                width="2"></v-progress-circular>
            </template>
          </v-list-item>
        </v-list>
      </v-dialog>
      <!-- <v-overlay :model-value="httpStore.showLoading" class="align-center justify-center">
        <v-sheet class="text-center pa-4" :elevation="10" rounded :width="200" color="rgb(255,255,255,1)">
          <v-progress-circular color="primary" size="64" indeterminate></v-progress-circular>
          <v-sheet class="mt-4" color="transparent">Processing request</v-sheet>
        </v-sheet>

      </v-overlay> -->
      <!-- <v-snackbar theme="light"  v-model="systemStore.messageVisible" color="deep-purple-accent-4"
      elevation="24">Bla</v-snackbar> -->
      <v-snackbar class="pa-0" elevation="24" theme="light" content-class="snackbar-style"
        :color="systemStore.messageColor" timer="white" location="top" v-model="systemStore.messageVisible"
        :timeout="systemStore.messageTimeout">
        <template v-slot:text class="pa-0 ma-0">
          <v-alert tile class="ma-0" theme="light" v-for="msg in systemStore.messageList" :text="msg"
            :type="systemStore.messageColor"></v-alert>
        </template>
        <template v-slot:actions>
          <v-btn class="ml-2" :color="systemStore.messageColor" variant="elevated"
            @click="systemStore.messageVisible = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-main>
  </v-app>
</template>

<script setup>
import './assets/base.css'
import { ref, onMounted } from 'vue'
import { useHttpStore } from '@/stores/http'
import { useSystemStore } from '@/stores/system'
import { useAuthStore } from '@/stores/auth'
import dell_logo from '@/assets/img/logo/dell_logo.png'

const httpStore = useHttpStore()
const systemStore = useSystemStore()
const authStore = useAuthStore()


onMounted(() => {



  const pageAccessedByReload = (
    (window.performance.navigation && window.performance.navigation.type === 1) ||
    window.performance
      .getEntriesByType('navigation')
      .map((nav) => nav.type)
      .includes('reload')
  );

  if (pageAccessedByReload) {
    var ast = sessionStorage.getItem('assets')
    systemStore.storeData.assets = ast
  } else {
    systemStore.setData('assets', {})
    sessionStorage.setItem('assets', {})
  }

  systemStore.reloadAllData()

  httpStore.token = sessionStorage.getItem("accessToken");
  if (httpStore.token != null && httpStore.token.trim().length > 0) {
    systemStore.getUserDetails().then(res => {
      systemStore.userDetail = res.userDetail
    })
      .catch(error => {
        sessionStorage.setItem("accessToken", '');

        httpStore.token = "";
        systemStore.routerTo('login')
      })
  }

})

/* const reloadAllData = () => {
  httpStore.apiAll([
    systemStore.getElementLinks(),
    systemStore.getAllLanguages(),
    systemStore.getLanguageDictionary()]
  ).then(result => {
    systemStore.selectedLanguage = ''
    systemStore.defaultDataLoaded = true

    var lsLanguage = localStorage.getItem("selectedLanguage")
    systemStore.selectedLanguage = lsLanguage == null || lsLanguage == '' ? 'en' : lsLanguage
    localStorage.setItem("selectedLanguage", systemStore.selectedLanguage)
  }).catch(error => {
    var t = error
  })
} */


// deprecated way of checking page reloaded
// if (window.performance) {
//   console.info("window.performance works fine on this browser");
// }
// console.info(performance.navigation.type);
// if (performance.navigation.type == performance.navigation.TYPE_RELOAD) {
//   console.info( "This page is reloaded" );
// } else {
//   console.info( "This page is not reloaded");
// }

// new way of checking if pagr was reloaded


</script>

<style>
.snackbar-style {
  padding: 0px;
}

#body {
  font-family: "Roboto", sans-serif;
  ;
}

v-app {
  position: fixed;
  width: inherit;
}

.router-anim-enter-active {
  animation: coming 100ms;
  animation-delay: 150ms;
  opacity: 0;
}


.router-anim-leave-active {
  animation: going 100ms;

}

@keyframes going {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50px);
    opacity: 0;
  }
}

@keyframes coming {
  from {
    transform: translateX(-50px);
    opacity: 0;
  }

  to {
    transform: translateX(0px);
    opacity: 10;
  }
}
</style>